import { notification } from 'antd';

const LOCALSTORAGE_KEY = '__FX_IE_MESSAGE__';

let isMessage = false;

/**
 * 检测 IE 浏览器并弹出切换浏览器提示。
 * 首次调用仅初始化标志，第二次起才执行检测，避免页面初始化时误触发。
 * 用户关闭提示后写入 localStorage，防止每次刷新重复弹出。
 */
export function isIEMessage() {
  if (!isMessage) {
    isMessage = true;
    return;
  }

  const isIEMessage = localStorage.getItem(LOCALSTORAGE_KEY);

  if (isIEMessage) {
    return;
  }

  const UA = window.navigator.userAgent.toLowerCase();
  const isIE = /msie|trident/.test(UA);

  if (isIE) {
    notification.info({
      message: '温馨提示',
      description:
        '为了更好的使用体验，请切换浏览器内核为极速内核或者使用谷歌浏览器访问',
      duration: null,
      onClose() {
        localStorage.setItem(LOCALSTORAGE_KEY, LOCALSTORAGE_KEY);
      },
    });
  }
}
